/**
 * 이슈 게시판 편집·삭제 권한 술어 — 화면의 버튼 노출은 **서버가 강제하는 규칙과 같은
 * 술어**로 정한다(DESIGN-issue-board-edit-delete §3 web). 버튼마다 조건을 따로 적으면
 * 한쪽만 바뀌어 "보이는데 거절" 또는 "되는데 안 보임"이 난다.
 *
 * 서버(BFF issue_service_server.py):
 *  - 이슈 편집  `_require_author`                — 작성자만, admin 제외(발언 변조 방지)
 *  - 댓글 편집  `_require_comment_author`        — 댓글 작성자만
 *  - 댓글 삭제  `_require_comment_author_or_admin` — 댓글 작성자 또는 admin
 *  - 지운 댓글은 편집·삭제 대상이 아니다(NOT_FOUND)
 */
import type { IssueCommentItem, IssueItem } from '@/app/services/issue/issueService';

export interface Viewer {
  /** 로그인 사용자 id — 프로필이 아직 없으면 빈 값(아무 권한도 없다) */
  id: string;
  isAdmin: boolean;
}

export function canEditIssue(issue: Pick<IssueItem, 'authorId'>, viewer: Viewer): boolean {
  return viewer.id !== '' && issue.authorId === viewer.id;
}

export function canEditComment(
  comment: Pick<IssueCommentItem, 'authorId' | 'deleted'>,
  viewer: Viewer,
): boolean {
  return !comment.deleted && viewer.id !== '' && comment.authorId === viewer.id;
}

export function canDeleteComment(
  comment: Pick<IssueCommentItem, 'authorId' | 'deleted'>,
  viewer: Viewer,
): boolean {
  if (comment.deleted) return false;
  if (viewer.id === '') return false; // 프로필 없음 = 아무 권한도 없다 — admin 플래그보다 먼저
  if (viewer.isAdmin) return true;
  return comment.authorId === viewer.id;
}
